<template>
    <el-select 
    :size="size" 
    v-model="bindValue" placeholder="请选择" 
    :style="{width: width}" @change="updateValue">
        <el-option
            v-for="(item, i) in options"
            :key="i"
            :label="item.label"
            :value="String(item.value)"
            :disabled="item.disabled">
        </el-option>
    </el-select>
</template>

<script>
    /**
     * 基于element-ui的Select封装，将需要参数配置封装，使用v-model直接绑定
     * @author zjs
     * @time 2017-06-12
     */
    export default {
        name: 'LySelect',
        props: {
            api: {
                type: String,
                default: ''
            }, // 数据请求地址
            all: { // 是否有全部选项
                type: Boolean,
                default: true
            },
            width: {
                type: String,
                default: '100%'
            },
            value: {
                type: [Number, String, Object],
                default: ''
            },
            size: {
                type: String,
                default: 'small'
            },
            defData: {
                type: Array,
                default: () => []
            }, // 自定义数据，当没api时，使用自定义数据，部进行数据请求
            defOne: {
                type: Boolean,
                default: false
            }, // 标识是否默认选中第一个数据
            bindObj: {
                type: true,
                default: false // 标志绑定对象，而不是普通的值类型（2018-08-13 添加） 
            },
            watchField: { // 监听变化的值，也作为搜索的参数
                type: [String, Number, Object]
            },
        },
        data () {
            return {
                options: [],
                bindValue: ''
            }
        },
        created () {
            // this.refValue()
            // 没有api 有默认数据时
            if ((!this.api || this.api.length < 1) && this.defData.length > 0) {
               this.hasData()
            } else {
                this.query()
            }
        },
        watch: {
            /**
             * 搜索关联字段，值变化的监听
             * @param  {[type]} v [description]
             * @return {[type]}   [description]
             */
            watchField (v) {
                if (v) {
                    this.options.forEach((element) => {
                        if (String(v['weidu_id']) === String(element.value)) {
                            this.$set(this, 'bindValue', String(element.value))
                            this.updateValue(this.bindValue)
                        }
                    })
                }
            },
            api (val) {
                if (val) {
                    this.query()
                }
            },
            value: {
                handler (val) {
                    let temp = val
                    if (typeof val === 'object') {
                        temp = val && val.value || ''
                    }
                    if (String(temp).length > 0) {
                        this.refValue()
                    } else if (this.bindValue.length > 0) {
                        this.bindValue = ''
                    }
                },
                immediate: true
            },
            defData (val) {
                if (val && val.length > 0) {
                    this.hasData()
                }
            }
        },
        methods: {
            // 是否有全部的处理
            isAll () { 
                if (this.all) {
                    this.bindValue = 'all'
                    this.options.unshift({
                        value: 'all',
                        label: '全部'
                    })
                }
                if (this.defOne) {                     
                    this.$nextTick(() => {
                        this.$set(this, 'bindValue', String(this.options[0]['value']))
                        // this.updateValue(this.bindValue)
                    })
                }
                // this.updateValue(this.bindValue)
            },
            // 有默认数据时处理
            hasData () {
                this.options = this.$utils.deepClone(this.defData)
                this.isAll()
                // if (!this.all) { // 设置默认选中数据
                    // this.$set(this, 'bindValue', this.options[0]['value'])
                    // this.updateValue(this.bindValue)
                // }
                this.refValue()
            },
            query () {
                this.options = []
                this.$api.query(this.api).then((rs) => {
                    this.options = rs
                    this.isAll()
                    // 设置回填数据             
                    this.$nextTick(() => {
                        this.refValue()
                    })
                }).catch((err) => {
                    console.error('select query error:%O', err)
                })
            },
            refValue () {
                let v = this.value
                if (typeof v === 'object') {
                    v = v ? v.value : 0
                }
                if (v && this.value !== this.bindValue) {
                    this.$set(this, 'bindValue', String(v))
                }
                this.updateValue(this.bindValue)
            },
            updateValue (val) {
                let temp = val // 用于匹配当前值的中间变量
                if (this.bindObj) {
                    val = this.getObjectByValue(val)
                    temp = val && val.value || ''
                }
                if (temp !== '' && String(temp) !== String(this.value)) {  // 转为字符串判断，避免类型不一致引起的问题
                    this.$emit('input', val)
                }
            },
            /**
            * 根据value的值获得对象，通常这个value就是唯一标识
            * 2018-08-13 添加
            */
            getObjectByValue (value) {
                let obj = null
                for (let i = 0, len = this.options.length; i < len; i++) {
                    if (String(value) === String(this.options[i]['value'])) {
                        obj = this.options[i]
                        break
                    }
                }
                return obj
            }
        }
    }
</script>